exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-subheader-velocidad {\n  font-size: 12px;\n  font-weight: normal;\n  height: auto;\n}\n.widgets .v-input--slider {\n  margin-top: 20px;\n}\n", ""]);

// exports
